import React from 'react';
import useIsMobile from '@/hooks/useIsMobile';
import useList from './useList';
import ProductListDesktop from './desktop';
import ProductListMobile from './mobile';

const ProductList = () => {
  const isMobile = useIsMobile(992);
  const viewModel = useList();

  return isMobile ? <ProductListMobile viewModel={viewModel} /> : <ProductListDesktop viewModel={viewModel} />;
};

export default ProductList;
